enum LoggedInUser {
  YES,
  NO,
  UNKNOWN,
}

export default LoggedInUser;
